import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'summariseNumber'
})
export class SummariseNumberPipe implements PipeTransform {

  transform(value: number | string): string {
    return Math.abs(Number(value)) >= 1.0e+9 ? (Math.abs(Number(value)) / 1.0e+9).toFixed(2) + $localize` میلیارد`
      // Six Zeroes for Millions
      : Math.abs(Number(value)) >= 1.0e+6

        ? (Math.abs(Number(value)) / 1.0e+6).toFixed(2) + $localize` میلیون`
        // Three Zeroes for Thousands
        : Math.abs(Number(value)) >= 1.0e+3

          ? (Math.abs(Number(value)) / 1.0e+3).toFixed(2) + $localize` هزار`

          : Math.abs(Number(value)).toString()
  }

}
